module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1517-dc6b8005f96f3724359e41924feb7335.png";